import React, { useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { InvoiceDetail, InvoicesList } from 'src/components/Invoices';
import InvoicesWithPaymentEdit from 'src/components/Invoices/InvoicesWithPaymentEdit';
import DefaultLayout from 'src/components/layouts/DefaultLayout';
import { AuthorizationContext } from 'src/context/AuthorizationProvider';

export const InvoicesPage = () => {
  const { customerId } = useContext(AuthorizationContext);
  const { accounts } = useMsal();
  const { t } = useTranslation('user', { keyPrefix: 'invoices' });

  const userId = accounts[0]?.idTokenClaims?.sub;

  return (
    <DefaultLayout title={t('title')}>
      <InvoicesList customerId={customerId} userId={userId} />
    </DefaultLayout>
  );
};

export const InvoicePage = () => {
  const { t } = useTranslation('user', { keyPrefix: 'invoices' });

  return (
    <DefaultLayout title={t('detail')}>
      <InvoiceDetail />
    </DefaultLayout>
  );
};

export const PropertyInvoicesPage = () => {
  const { customerId } = useContext(AuthorizationContext);
  const params = useParams();
  const { t } = useTranslation('user', { keyPrefix: 'invoices' });

  return (
    <DefaultLayout title={t('title')}>
      <InvoicesWithPaymentEdit customerId={customerId} userId={params.userId} />
    </DefaultLayout>
  );
};
